var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSourcesFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 104,
    viewBox: "0 0 143 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Defualt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0908203 15.1031H128.032C136.248 15.1031 142.909 20.738 142.909 27.689V90.6185C142.909 97.5695 136.248 103.204 128.032 103.204H71.4999H14.9677C6.75144 103.204 0.0908203 97.5695 0.0908203 90.6185V15.1031Z",
    fill: "#FBBC1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0908203 33.9819V85.5841C0.0908203 92.5351 6.75144 98.17 14.9677 98.17H128.032C136.248 98.17 142.909 92.5351 142.909 85.5841V32.7233C142.909 25.7723 136.248 20.1374 128.032 20.1374H65.5491V26.4304C65.5491 30.601 61.5528 33.9819 56.623 33.9819H0.0908203Z",
    fill: "url(#paint0_linear_1774_14508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0908203 10.0687C0.0908203 4.50792 5.41931 0 11.9923 0H53.6476C60.2207 0 65.5491 4.50792 65.5491 10.0687V15.1031H0.0908203V10.0687Z",
    fill: "#FBBC1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1774_14508",
    x1: 0.0908203,
    y1: 0,
    x2: 171.058,
    y2: 121.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC937"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSourcesFolderIcon);
export default __webpack_public_path__ + "static/media/data-sources-folder-icon.f8bc604145b15f94bce81caf27140209.svg";
export { ForwardRef as ReactComponent };